import React from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import whatsappIcon from '../db_svg/whatsapp.svg';

function digitsOnly(value) {
  return String(value ?? '').replace(/\D/g, '');
}

export function WhatsAppFloat() {
  const { t } = useTranslation();
  const phone = digitsOnly(process.env.REACT_APP_WHATSAPP_NUMBER);
  if (!phone) return null;

  const href = `https://wa.me/${phone}`;

  const node = (
    <div className="group pointer-events-none fixed bottom-[calc(7rem+env(safe-area-inset-bottom,0px))] right-4 z-[9999] sm:bottom-[calc(6rem+env(safe-area-inset-bottom,0px))] sm:right-6 md:bottom-[calc(4rem+env(safe-area-inset-bottom,0px))] lg:bottom-6">
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t('whatsapp.ariaLabel')}
        title={t('whatsapp.title')}
        className="pointer-events-auto relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-lg shadow-black/25 ring-white/30 transition hover:brightness-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent"
      >
        <img src={whatsappIcon} alt="" className="h-8 w-8" draggable={false} />
      </a>
      <span
        role="tooltip"
        className="pointer-events-none absolute bottom-full left-1/2 mb-2 -translate-x-1/2 whitespace-nowrap rounded-lg border border-white/10 bg-white px-2.5 py-1.5 text-sm font-medium text-gray-900 shadow-lg opacity-0 transition-opacity duration-200 group-hover:opacity-100 group-focus-within:opacity-100"
      >
        {t('whatsapp.tooltip')}
      </span>
    </div>
  );

  return createPortal(node, document.body);
}
